module.exports = __webpack_public_path__ + "media/components/videos_internal/dr_you_6_1-final-53d5ea32d3080bf04c68ad6e58efce8e.jpg";